export const assertNever = (_: never) => {
  throw new Error('This code should not be called')
}
